/**
 * Searches for a specific parent of a element,
 * using a callback function as the source of
 * truth in order to determine which is the correct
 * parent.
 *
 * @param element The element where the process
 * starts.
 *
 * @param checkParent A callback that will be
 * called for each of the ancestors of the element
 * until the desired parent is found.
 * This function should return **true when found**
 * the desired parend was found, **null to cancel**
 * the search or **false to continue searching**.
 *
 * @returns The specific parent or null in case
 * the root parent element is raised.
 */
export function getSpecificParent(
  element: HTMLElement | null,
  checkParent: (parent: HTMLElement) => boolean | null,
): HTMLElement | null {
  let currentElement = element;

  while (element !== document.documentElement && currentElement) {
    const hasFoundTheParent = checkParent(currentElement);
    if (hasFoundTheParent === null) return null;
    if (hasFoundTheParent) return currentElement;

    const parent = currentElement.parentElement;
    if (parent) currentElement = parent;
    else return null;
  }

  return null;
}
